module.exports = __webpack_public_path__ + "img/tentang-pandai2.ad104915.jpg";